import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';

// Custom timeout error with minimal metadata
export class TimeoutError extends Error {
  readonly isTimeout = true;
  readonly status?: number;
  constructor(message: string, opts?: { status?: number; cause?: unknown }) {
    super(message);
    this.status = opts?.status;
    if (opts?.cause) {
      (this as any).cause = opts.cause;
    }
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}

export const throwApiError = (err: unknown, context?: any): never => {
  // Preserve cancellation semantics
  if (axios.isCancel(err)) {
    throw err;
  }

  const axiosErr = axios.isAxiosError(err) ? err : undefined;
  const status = axiosErr?.response?.status;
  const hasExcludedBrand = !!context?.excludedBrand?.length;

  // Timeout classification: 502 + non-empty excludedBrand
  if (status === 502 && hasExcludedBrand) {
    throw new TimeoutError('Request timed out while processing brand exclusions.', { status, cause: err });
  }

  // Generic fallback – preserve original message, attach cause
  const baseMessage = axiosErr?.message ?? (err instanceof Error ? err.message : String(err));
  const generic = new Error(`An error has occurred: ${baseMessage}`);
  (generic as any).cause = err;
  throw generic;
};

export const setApiErrorState = (err: any, setIsApiError: Dispatch<SetStateAction<boolean>>): void => {
  if (err instanceof TimeoutError) {
    setIsApiError(true);
  }
};
